import React, { Component } from 'react';
import styles from './index.module.css';
import PropTypes from 'prop-types';
import utils from '@utils';

const CONTAINER_WIDTH_DEFAULT = 320 * 0.5;
const CONTAINER_HEIGHT_DEFAULT = 200 * 0.5;

class MapMini extends Component {
  constructor(props) {
    super(props);

    //zoom: 0.2, 0.5, 1
    /*this.state = {
      zoom: 1
    };*/
    this.state = {
      status: true,
      startPos: { x: 0, y: 0 },
      curPos: { x: 0, y: 0 },
      lastPos: { x: 0, y: 0 },
      offsetX: 0,
      offsetY: 0,
    };

    this.containerWidth = this.props.width;
    this.containerHeight = this.props.height;

    this.mapLayerRef = React.createRef();
    this.frameRef = React.createRef();

    this._onMouseUp = this._onMouseUp.bind(this);
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onMouseDown = this._onMouseDown.bind(this);

    this._onContainerMouseDown = this._onContainerMouseDown.bind(this);
  }

  _onMouseDown(event, initParams = {}) {
    event.preventDefault();
    //event.stopPropagation();
    if (this.props.zoom <= 1) {
      return;
    }

    const cursorPosition = initParams.cursorPosition
      ? initParams.cursorPosition
      : utils.getCursorPosition(event);
    const offset = initParams.offsetX
      ? { x: initParams.offsetX, y: initParams.offsetY }
      : { x: this.state.offsetX, y: this.state.offsetY };

    document.addEventListener(utils.events.mousemove, this._onMouseMove);
    document.addEventListener(utils.events.mouseup, this._onMouseUp);

    const containerPos = this.mapLayerRef.current.getBoundingClientRect();

    this.setState({
      status: true,
      startPos: { x: cursorPosition.cx, y: cursorPosition.cy },
      curPos: { x: 0, y: 0 },
      lastPos: {
        x: offset.x * containerPos.width,
        y: offset.y * containerPos.height,
      },
    });

    return false;
  }

  removeEvents() {
    document.removeEventListener(
      utils.events.mousemove,
      this._onMouseMove,
      false,
    );
    document.removeEventListener(utils.events.mouseup, this._onMouseUp, false);
  }

  _onContainerMouseDown(event) {
    event.preventDefault();
    //event.stopPropagation();

    const cursorPosition = utils.getCursorPosition(event);

    const containerPos = this.mapLayerRef.current.getBoundingClientRect();
    const frameWidth =
      containerPos.width / this.props.zoom; /* - BORDER_WIDTH * 2*/
    const frameHeight =
      containerPos.height / this.props.zoom; /* - BORDER_WIDTH * 2*/

    const pointerOffset = {
      x:
        (cursorPosition.cx - containerPos.left - frameWidth * 0.5) /
        containerPos.width, //this.containerWidth,
      y:
        (cursorPosition.cy - containerPos.top - frameHeight * 0.5) /
        containerPos.height, //this.containerHeight
    };

    this.setState(() => ({
      offsetX: pointerOffset.x,
      offsetY: pointerOffset.y,
    }));

    this.props.onGlide({
      x: pointerOffset.x,
      y: pointerOffset.y,
    });

    this._onMouseDown(event, {
      cursorPosition,
      offsetX: pointerOffset.x,
      offsetY: pointerOffset.y,
    });

    return false;
  }

  _onMouseMove(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.state.status) {
      return false;
    }

    const containerPos = this.mapLayerRef.current.getBoundingClientRect();

    const cursorPosition = utils.getCursorPosition(event);
    const transformX =
      (cursorPosition.cx - this.state.startPos.x + this.state.lastPos.x) /
      containerPos.width;
    const transformY =
      (cursorPosition.cy - this.state.startPos.y + this.state.lastPos.y) /
      containerPos.height;

    this.setState(state => ({
      curPos: {
        x: cursorPosition.cx - state.startPos.x,
        y: cursorPosition.cy - state.startPos.y,
      },
      offsetX: transformX,
      offsetY: transformY,
    }));

    this.props.onGlide({
      x: transformX,
      y: transformY,
    });

    return false;
  }

  _onMouseUp(event) {
    event.preventDefault();

    if (this.state.status) {
      this.setState({
        status: false,
      });
      this.removeEvents();
    }
  }

  setFrameOffset(x, y) {
    this.setState({ offsetX: x, offsetY: y });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.offsetX !== this.props.offset.x ||
      prevState.offsetY !== this.props.offset.y
    ) {
      this.setFrameOffset(this.props.offset.x, this.props.offset.y);
    }
  }

  componentDidMount() {
    this.mapLayerRef.current.addEventListener(
      utils.events.mousedown,
      this._onContainerMouseDown,
      { passive: false },
    );
    this.frameRef.current.addEventListener(
      utils.events.mousedown,
      this._onMouseDown,
      { passive: false },
    );
  }

  componentWillUnmount() {
    this.mapLayerRef.current.removeEventListener(
      utils.events.mousedown,
      this._onContainerMouseDown,
      { passive: false },
    );
    this.frameRef.current.removeEventListener(
      utils.events.mousedown,
      this._onMouseDown,
      { passive: false },
    );
  }

  render() {
    const props = this.props;
    const zoom = this.props.zoom;
    const transformX = props.offset.x * this.containerWidth;
    const transformY = props.offset.y * this.containerHeight;
    const frameWidth = this.containerWidth / zoom; /* - BORDER_WIDTH * 2*/
    const frameHeight = this.containerHeight / zoom; /* - BORDER_WIDTH * 2*/

    const innerLayerStyle = {
      width: this.containerWidth,
      height: this.containerHeight,
      backgroundImage: `url(${props.bitmap})`,
    };
    const frameStyle = {
      width: frameWidth,
      height: frameHeight,
      transform: `translate(${transformX}px, ${transformY}px)`,
    };

    return (
      <div
        className={styles.container_outer}
        style={{ width: this.containerWidth, height: this.containerHeight }}>
        <div
          ref={this.mapLayerRef}
          style={innerLayerStyle}
          className={styles.container_inner}>
          <div
            style={frameStyle}
            ref={this.frameRef}
            className={styles.frame}
          />
        </div>
      </div>
    );
  }
}

MapMini.defaultProps = {
  width: CONTAINER_WIDTH_DEFAULT,
  height: CONTAINER_HEIGHT_DEFAULT,
};

MapMini.propTypes = {
  onGlide: PropTypes.func.isRequired,
  bitmap: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default MapMini;
